/**
 * Runtime → Inference — redirects to the existing Models runtime page
 * (which already shows vLLM gateway health + loaded engines).
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/runtime/inference')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/models/runtime' });
  },
});
